export default __webpack_public_path__ + "static/helveticaneue-bold-6ee127db072b5d8ae70fc898799569c3.woff";